import React from "react"
import Parse from "html-react-parser"
import {LazyLoadImage} from 'react-lazy-load-image-component'
class LayoutOne extends React.Component {
    constructor() {
        super();
        this.state = {
            subCategory: {}
        }
    }

    componentDidMount() {
        this.setState({subCategory: this.props.subCategory})
    }

    render() {
        let {subCategory} = this.state;
        let {chooseProduct, currency} = this.props;
        return (
            <div className="box-colum">
                <div className="box-contants">
                    <div className="price-icon">
                        {subCategory && subCategory.image && subCategory.image.url ?
                            <LazyLoadImage src={subCategory.image.url}/> : null}
                    </div>
                    <h4 className="title"><a>{subCategory.name}</a></h4>
                    <div className="description">{subCategory.description ? Parse(subCategory.description) : null}</div>
                    {subCategory && subCategory.products && subCategory.products.length ? subCategory.products.map((item, key) => {
                        return (
                            <div className="product-add" key={key}>
                                <span>&nbsp;</span>
                                <div className="box-contant-left"><p>{item.name}</p></div>
                                <div className="box-contant-right"><p
                                    onClick={() => {
                                        chooseProduct({...item, layout: subCategory.layout});
                                        window.okfunction()
                                    }}>
                                    <strong>{currency} {item.price.toFixed(2)} </strong>
                                    <i className="fa fa-plus"
                                       aria-hidden="true"></i>
                                </p>
                                </div>
                            </div>
                        )
                    }) : null}


                </div>
            </div>
        )
    }
}

export default LayoutOne;
